import {
  queryKeyBounds,
  queryKeyDestinationId,
  queryKeyDestinationName,
  queryKeyLandmarkId,
  queryKeyLandmarkName,
  queryKeyPropertyId,
  queryKeyPropertyName,
} from 'constants/url'

const locationQueryParams = [
  queryKeyDestinationId,
  queryKeyDestinationName,
  queryKeyLandmarkId,
  queryKeyLandmarkName,
  queryKeyPropertyId,
  queryKeyPropertyName,
]

/**
 * Converts map search parameters to list search parameters while retaining the
 * original location after a bounds search has replaced it in the map URL.
 */
export function getListViewSearch(windowSearch: string, previousDestination?: string): string {
  const currentSearchParams = new URLSearchParams(windowSearch)
  currentSearchParams.delete(queryKeyBounds)

  const hasCurrentLocation = locationQueryParams.some(param => currentSearchParams.has(param))
  if (!hasCurrentLocation && previousDestination) {
    const previousSearchParams = new URLSearchParams(previousDestination)
    locationQueryParams.forEach(param => {
      previousSearchParams.getAll(param).forEach(value => currentSearchParams.append(param, value))
    })
  }

  const search = currentSearchParams.toString()
  return search ? `?${search}` : ''
}
